import { render, staticRenderFns } from "./myMembers.vue?vue&type=template&id=3b13acda&scoped=true&"
import script from "./myMembers.vue?vue&type=script&lang=js&"
export * from "./myMembers.vue?vue&type=script&lang=js&"
function injectStyles (context) {
  
  var style0 = require("../../../assets/css/leftnavChat.css?vue&type=style&index=0&id=3b13acda&scoped=true&lang=css&")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "3b13acda",
  "5233f788"
  
)

export default component.exports